const {Backbone} = require('backboneAdapter');
import NavBarView from 'js/views/navbar.view';
import ChartView from 'js/views/reports-message-chart-simpleview';
import creditsTileView from 'js/views/credits-tile-simpleview';
import campaignTileView from 'js/views/campaign-tile-simpleview';
import contactTileView from 'js/views/contact-tile.view';
import emailSmsTileView from 'js/views/email-sms-tile-simpleview';
import redeemersView from 'js/views/redeemers.analytics.view';
import bouncedGroupView from 'js/views/bouncedGroup.analytics.view';

export default Backbone.Router.extend({
    routes : {
        "" : "defaultRoute",
        ":specific" : "specificRoute"
    },
    initialize : function () {
        this.navbar = new NavBarView();
    },
    defaultRoute : function () {
        console.info("defaultRoute");
        creditsTileView.init('.credits-tile');
        campaignTileView.init("#campaigns-tile");
        contactTileView.init('#contact-tile');
        emailSmsTileView.init('#email-sms-report-tile');
        (new ChartView).init('.container');
        redeemersView.init("#redeemersDiv");
        bouncedGroupView.init("#bouncedGroupDiv");
    },
    specificRoute : function (specific) {
        this.defaultRoute();
        setTimeout(function() {
            $(`#${specific}-link`).click();
        }, 2000);
    }
});
